import React from 'react';
import PropTypes from 'prop-types';

function Paypal({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="32"
      viewBox="0 0 40 32"
      className={className}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-25 -48)">
          <g>
            <g fillRule="nonzero" transform="translate(25 48)">
              <path
                fill="#009BDE"
                d="M25.567 4.392c.202-1.343 0-2.263-.698-3.088C24.105.39 22.716 0 20.941 0h-5.145a.747.747 0 00-.728.652l-2.142 14.197a.452.452 0 00.435.53h3.181l-.22 1.452c-.037.243.147.467.38.467h2.68a.654.654 0 00.636-.57l.024-.14.502-3.343.03-.185a.654.654 0 01.637-.57h.397c2.594 0 4.626-1.099 5.22-4.282.25-1.33.122-2.442-.54-3.222a2.422 2.422 0 00-.721-.594"
              />
              <path
                fill="#022169"
                d="M24.88 1.304C24.113.39 22.723 0 20.947 0h-5.15a.748.748 0 00-.728.652l-2.144 14.193a.452.452 0 00.435.53h3.184l.796-5.284-.024.166c.055-.37.361-.652.723-.652h1.512c2.97 0 5.29-1.259 5.97-4.895.025-.109.037-.211.055-.32.203-1.342 0-2.262-.698-3.086z"
              />
              <path
                fill="#009BDE"
                d="M27.16 23.853c-.171 1.163-1.015 1.163-1.839 1.163h-.464l.332-2.177a.26.26 0 01.255-.228h.218c.56 0 1.08 0 1.355.337.161.2.209.497.142.905zm-.351-3.031h-3.09a.442.442 0 00-.425.377l-1.251 8.31a.262.262 0 00.256.307h1.582c.152 0 .275-.109.294-.268l.35-2.356a.428.428 0 01.427-.377h.976c2.037 0 3.212-1.034 3.515-3.081.142-.895.01-1.6-.398-2.088-.427-.536-1.204-.824-2.236-.824z"
              />
              <path
                fill="#002F87"
                d="M5.12 23.853c-.17 1.163-1.013 1.163-1.838 1.163h-.464l.332-2.177a.26.26 0 01.256-.228h.218c.559 0 1.08 0 1.354.337.162.2.209.497.143.905zm-.35-3.031H1.681a.442.442 0 00-.426.377l-1.25 8.31a.262.262 0 00.255.307h1.478a.442.442 0 00.426-.377l.341-2.247a.428.428 0 01.427-.377h.976c2.037 0 3.212-1.034 3.515-3.081.142-.895.01-1.6-.398-2.088-.445-.536-1.222-.824-2.255-.824zM11.912 26.912c-.141.89-.811 1.49-1.66 1.49-.425 0-.774-.15-.991-.42-.218-.27-.303-.66-.227-1.1.132-.88.812-1.5 1.652-1.5.415 0 .755.15.981.43.217.28.312.67.245 1.1zm2.058-3.04h-1.472c-.123 0-.236.1-.255.23l-.066.44-.104-.16c-.321-.49-1.029-.65-1.737-.65-1.632 0-3.02 1.31-3.293 3.14-.142.91.056 1.79.547 2.4.453.56 1.095.79 1.86.79 1.311 0 2.038-.89 2.038-.89l-.066.43c-.029.16.094.31.255.31h1.33c.208 0 .387-.16.425-.38l.793-5.35c.019-.16-.104-.31-.255-.31z"
              />
              <path
                fill="#009BDE"
                d="M34.03 26.912c-.142.89-.812 1.49-1.661 1.49-.425 0-.774-.15-.991-.42-.217-.27-.302-.66-.227-1.1.133-.88.812-1.5 1.652-1.5.415 0 .755.15.982.43.217.28.311.67.245 1.1zm2.057-3.04h-1.472c-.123 0-.236.1-.255.23l-.066.44-.104-.16c-.32-.49-1.028-.65-1.736-.65-1.633 0-3.02 1.31-3.294 3.14-.141.91.057 1.79.547 2.4.453.56 1.095.79 1.86.79 1.312 0 2.038-.89 2.038-.89l-.066.43c-.028.16.095.31.255.31h1.33c.208 0 .388-.16.425-.38l.793-5.35c.019-.16-.104-.31-.255-.31z"
              />
              <path
                fill="#002F87"
                d="M21.826 23.827h-1.493a.402.402 0 00-.352.2l-2.064 3.184-.875-3.055a.431.431 0 00-.409-.32H15.17c-.18 0-.305.18-.247.36l1.645 5.062-1.55 2.286c-.124.18 0 .43.209.43h1.493c.143 0 .276-.07.352-.19l4.965-7.518c.123-.19 0-.44-.21-.44z"
              />
              <path
                fill="#009BDE"
                d="M37.795 21.051l-1.274 8.506c-.029.16.095.31.257.31h1.284c.209 0 .39-.16.428-.38l1.255-8.346a.26.26 0 00-.257-.31h-1.436c-.133-.01-.238.08-.257.22z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

Paypal.propTypes = {
  className: PropTypes.string,
};

Paypal.defaultProps = {
  className: undefined,
};

export default Paypal;
